import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicLanguageNotSupportedGuard,
  UnexpectedServiceErrorGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import LanguageWidgetsEmptyResultGuard from './LanguageWidgetsEmptyResultGuard'

const PostSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <TopicInaccessibleGuard widgetId={widgetId}>
      <UnexpectedServiceErrorGuard widgetId={widgetId}>
        <TopicIndexNotReadyGuard widgetId={widgetId}>
          <TopicLanguageNotSupportedGuard widgetId={widgetId}>
            <LanguageWidgetsEmptyResultGuard widgetId={widgetId}>
              {children}
            </LanguageWidgetsEmptyResultGuard>
          </TopicLanguageNotSupportedGuard>
        </TopicIndexNotReadyGuard>
      </UnexpectedServiceErrorGuard>
    </TopicInaccessibleGuard>
  </WidgetLoadingGuard>
)

export default PostSearchDataGuards
